import { ApiCommonParams } from "../../@types/apiTypes";
import { ApiResponse } from "../../apiResponse";
import Axios from "../../axios";
import { commonApiParamsToApiParams } from "../../helpers/paramsHelpers";

export function GetNewStudentsRequests(
  commonApiParams?: ApiCommonParams
): Promise<ApiResponse> {
  const params = commonApiParamsToApiParams(commonApiParams || {});
  return Axios.get(`v1/tutors/schedule_requests`, { params });
}
export function changeTutorsStudentsRequestStatus(
  id: string | number,
  body: object
): Promise<ApiResponse> {
  return Axios.put(`v1/tutors/schedule_requests/${id}`, body);
}
export function showApologizeRequests(
  commonApiParams?: ApiCommonParams
): Promise<ApiResponse> {
  const params = commonApiParamsToApiParams(commonApiParams || {});
  return Axios.get("v1/tutors/cancellations", { params });
}
export function updateApologizeRequests(
  id: number | string,
  body: object
): Promise<ApiResponse> {
  return Axios.put(`v1/tutors/cancellations/${id}`, body);
}
export function updateChangeScheduleRequests(
  id: number | string,
  body: object
): Promise<ApiResponse> {
  return Axios.put(`v1/tutors/schedule_requests/${id}`, body);
}
